export const heroMask = {
  name: 'hero-mask',
  path: 'M0,0 H1 V0.875 C1,0.875,0.79,0.993,0.551,1 C0.313,1,0,0.889,0,0.889 V0',
};
